import React from 'react';

import { legacyTextStyles } from '@eluve/components';

export interface ArtifactHeaderProps {
  text: string;
}

export const ArtifactHeader: React.FC<ArtifactHeaderProps> = ({ text }) => {
  return (
    <h2
      className={legacyTextStyles.title({
        size: 'm',
      })}
    >
      {text}
    </h2>
  );
};
